module.exports = __webpack_public_path__ + "img/kuangjiao_xc10.58013b99.jpg";